/* global __DEV__ */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import rp from 'request-promise-native'
import InputMask from 'react-input-mask'

import { uriV2, iuguAccountId } from '../../services/defaultProps'
import Interface from '../../components/Interface'

import detectBrowserLanguage from 'detect-browser-language'
import WhatsAppShopDoubt from '../../components/WhatsAppShopDoubt'
import Loader from 'react-loader-spinner'
import { AiOutlineCreditCard } from 'react-icons/ai'
import { unmaskString } from '../../services/ShopHelpers'

const renderLoading = () => (
  <div style={{ position: 'absolute', top: 100, left: '50%', transform: 'translate(-50%, 0)' }}>
    <Loader
      type='TailSpin'
      color='#6d357b'
      height='50'
      width='50'
    />
  </div>
)

class AddCard extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      cardName: (this.props.card && this.props.card.cardName) || '',
      cardNumber: (this.props.card && this.props.card.cardNumber) || '',
      cardExpirationDate: (this.props.card && this.props.card.cardExpirationDate) || '',
      cvv: (this.props.card && this.props.card.cvv) || '',
      cardNameError: false,
      cardNumberError: false,
      cardExpirationDateError: false,
      cvvError: false,
      language: 1
    }
  }

  componentWillMount () {
    if (!localStorage.getItem('language')) {
      if (detectBrowserLanguage() === 'pt-BR' || detectBrowserLanguage() === 'pt-PT' || detectBrowserLanguage() === 'pt' || detectBrowserLanguage().slice(0, 2) === 'pt') {
        this.setState({ language: 0 })
        localStorage.setItem('language', '0')
      }
      if (detectBrowserLanguage().slice(0, 2) === 'es') {
        this.setState({ language: 2 })
        localStorage.setItem('language', '2')
      }
    } else {
      this.setState({ language: localStorage.getItem('language') - '0' })
    }
    this.setState({isLoading: false})
  }

  handleContinueButton = async () => {
    if (!this.state.cardNumber || this.state.cardNumber.length < 16) {
      this.setState({cardNumberError: true})
      return
    }

    if (!this.state.cardExpirationDate || this.state.cardExpirationDate.length < 6) {
      this.setState({cardExpirationDateError: true})
      return
    }

    if (!this.state.cvv || this.state.cvv.length < 3) {
      this.setState({cvvError: true})
      return
    }

    if (!this.state.cardName) {
      this.setState({cardNameError: true})
      return
    }

    this.setState({isLoading: true})
    // send info to backend
    try {
      const cardData = await this.createIuguCardData({
        card: {
          number: this.state.cardNumber,
          validate: this.state.cardExpirationDate,
          cvv: this.state.cvv,
          name: this.state.cardName
        }
      })

      const response = await rp({
        uri: `${uriV2}/payment/iugu/card/client`,
        method: 'POST',
        headers: {
          Authorization: this.props.token
        },
        body: cardData,
        json: true
      })

      this.props.setPayerInfo({ card: response })

      if (this.props.location.state && this.props.location.state.serviceBilling) {
        return this.props.history.push('/cobrancas/finalizar-compra', {
          serviceBilling: this.props.location.state.serviceBilling
        })
      }

      return this.props.history.push('/finalizar-compra')
    } catch (err) {
      window.alert('Erro ao adicionar cartão! Verifique se as informações estão corretas!')
      console.error(err)
    }

    this.setState({isLoading: false})
  }

  renderContent = () => {
    return (
      <div style={{display: 'flex', flexDirection: 'column', height: 'calc(100vh - 50px)', width: '100%'}}>
        <h2 className='shop-description-header'>Insira os dados do cartão:</h2>
        <div style={{width: '90%', textAlign: 'center', maxWidth: '720px', marginLeft: 'auto', marginRight: 'auto', padding: 8}}>
          <div style={{}}>
            <div className='shop-input-header-div'>
              <h3 className={this.state.cardNumberError ? 'shop-input-header-error' : 'shop-input-header'}>Número do cartão</h3>
            </div>
            <div>
              <InputMask type='text' className={this.state.cardNumberError ? 'input-text-error' : 'input-text'}
                onChange={(e) => this.setState({cardNumber: unmaskString(e.target.value), cardNumberError: false})}
                value={this.state.cardNumber}
                mask='9999 9999 9999 9999'
                maskChar={null}
              />
            </div>
          </div>
          <div style={{display: 'flex'}}>
            <div style={{width: '50%', marginRight: 8}}>
              <div className='shop-input-header-div'>
                <h3 className={this.state.cardExpirationDateError ? 'shop-input-header-error' : 'shop-input-header'}>Validade</h3>
              </div>
              <div>
                <InputMask type='text' className={this.state.cardExpirationDateError ? 'input-text-error' : 'input-text'}
                  onChange={(e) => this.setState({cardExpirationDate: e.target.value, cardExpirationDateError: false})}
                  value={this.state.cardExpirationDate}
                  placeholder={'MM/AAAA'}
                  mask='99/9999'
                  maskChar={null}
                />
              </div>
            </div>
            <div style={{width: '50%'}}>
              <div className='shop-input-header-div'>
                <h3 className={this.state.cvvError ? 'shop-input-header-error' : 'shop-input-header'}>Dígito verificador</h3>
              </div>
              <div>
                <InputMask type='text' className={this.state.cvvError ? 'input-text-error' : 'input-text'}
                  onChange={(e) => this.setState({cvv: e.target.value, cvvError: false})}
                  value={this.state.cvv}
                  onKeyPress={this.handleKeyPress}
                  mask='9999'
                  maskChar={null}
                />
              </div>
            </div>
          </div>
          <div>
            <div className='shop-input-header-div'>
              <h3 className={this.state.cardNameError ? 'shop-input-header-error' : 'shop-input-header'}>Nome no cartão</h3>
            </div>
            <div>
              <input type='text' className={this.state.cardNameError ? 'input-text-error' : 'input-text'}
                onChange={(e) => this.setState({cardName: e.target.value, cardNameError: false})}
                value={this.state.cardName}
                onKeyPress={this.handleKeyPress}
              />
            </div>
          </div>
        </div>
        <div style={{backgroundColor: 'rgba(148, 66, 138, 0.5)', height: '1px', width: '90%', margin: 'auto', marginTop: 16, marginBottom: 16}} />
        <WhatsAppShopDoubt clientName={this.props.user.name} />

        <div onClick={this.handleContinueButton} style={{marginTop: 'auto', width: '100%'}}>
          <div id='purchase' >
            Continuar
          </div>
        </div>
      </div>
    )
  }

  createIuguCardData = async ({card}) => {
    const expiration = card.validate.split('/')
    let name = card.name.split(' ')
    const firstName = name.pop()
    const lastName = name.join(' ')

    window.Iugu.setAccountID(iuguAccountId)
    if (__DEV__) {
      window.Iugu.setTestMode(true)
    }
    const creditCard = window.Iugu.CreditCard(
      card.number,
      expiration[0],
      expiration[1],
      firstName,
      lastName,
      card.cvv
    )

    const iuguCreditCardHashQuery = new Promise((resolve, reject) => {
      window.Iugu.createPaymentToken(creditCard, async response => {
        if (response.errors) {
          console.error('erro: ', response.errors)
          reject(response.errors)
        } else {
          resolve(response)
        }
      })
    })

    const iuguResponse = await iuguCreditCardHashQuery
    const data = {
      fullname: card.name,
      last4: card.number.substr(card.number.length - 4),
      brand: iuguResponse.extra_info.brand,
      hash: iuguResponse.id,
      customerId: this.props.payerInfo && this.props.payerInfo.customerId
    }

    return data
  }

  render () {
    return (
      <Interface
        title='Dados de pagamento'
        history={this.props.history}
        showFooter={false}
        backgroundClass='shop-background'
        logoIcon={
          <AiOutlineCreditCard size='28'
            color='#94428a'
          />
        }
        customPadding={4}
      >
        {this.state.isLoading ? renderLoading() : this.renderContent()}
      </Interface>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer,
    card: state.productsReducer.card,
    payerInfo: state.productsReducer.payerInfo,
    deliveryAddress: state.productsReducer.payerInfo
  }
}

export default connect(mapStateToProps, actions)(AddCard)



// WEBPACK FOOTER //
// ./src/containers/Shop/AddCard.js